// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n\n/** 存放自定义的变量，可全局直接使用 */\n\n/** 主题色 */\n\n/** 字体样式 */\n\n/** 边框样式 */\n\n/** 错误样式 */\n\n/** 警告样式 */\n\n/** 可复用的模块化样式 */\n\n/**\n * 设置多行文本超出隐藏\n * $n 为规定多少行\n*/\n.changeRecord[data-v-09a0fcec] {\n  padding: 0.104167rem;\n  box-sizing: border-box;\n  height: 2.604167rem;\n  display: flex;\n  flex-direction: column;\n}\n.changeRecord .table-flex[data-v-09a0fcec] {\n  flex: 1;\n}\n.changeRecord .title-from[data-v-09a0fcec] {\n  margin-bottom: 0.104167rem;\n}", ""]);
// Exports
module.exports = exports;
